import { useColorModeValue, useToast } from '@chakra-ui/react';
import { ChakraComponents as CC } from '@Modules/core/lib/chakra';
import CustomerStatusHistoryFormUI from '@Modules/cardManagementSystem/cardholder/components/forms/cardData/customer/CustomerStatusHistoryFormUI';
import CustomReactTable from '@Modules/core/components/table/CustomReactTable';
import { useMutation, useQuery } from '@tanstack/react-query';
import { getCustomerStatusHistoryDataTableColumns } from './CustomerStatusHistoryDataTableMeta';
import customerStatusHistoryFormMeta from './CustomerStatusHistoryFormMeta';

const CustomerStatusHistoryMixedHandler = () => {
  const toast = useToast();

  //   Initialize react Query to GET Data
  const queryKey = ['CustomerStatusHistory'];
  const { data, isLoading } = useQuery({
    queryKey: queryKey,
    queryFn: async () => {
      // TODO: Replace this by your fetcher function
      return new Promise(function (resolve) {
        setTimeout(() => resolve('data'), 500);
      });
    },
    onSuccess: (data_: any) => {
      // console.log(data_);
    },
    onError: (data_: any) => {
      toast({
        position: 'top-right',
        title:
          "Une erreur inattendue s'est produite lors de la récupération des données",
        isClosable: true,
        status: 'error',
      });
    },
  });

  const { isLoading: isSubmitting } = useMutation(async () => {}, {
    onSuccess: (data) => {
      console.log('Response: ', data);
      toast({
        position: 'top-right',
        title: 'Sauvegarde effectuée avec succès',
        isClosable: true,
        status: 'success',
      });
    },
    onError: (error) => {
      toast({
        position: 'top-right',
        title:
          "Une erreur inattendue s'est produite lors de l'enregistrement des données",
        isClosable: true,
        status: 'error',
      });
      console.log('Error: ', error);
    },
  });

  const onSubmit = async (payload: any) => {
    console.log('payload: ', payload);
    // TODO: Uncomment the following lines to put the logic of backend feedback operation
    /*try {
         await mutateAsync();
     } catch (error) {
         console.log(error);
     }*/
  };

  const columns = getCustomerStatusHistoryDataTableColumns({
    isLoading,
  });

  const bg = useColorModeValue('white', 'gray.800');

  return (
    <>
      <CustomerStatusHistoryFormUI
        meta={customerStatusHistoryFormMeta}
        onSubmit={onSubmit}
        isLoading={isLoading}
        isSubmitting={isSubmitting}
        mb={12}
      />

      <CustomReactTable data={data || [{}, {}, {}]} columns={columns} />

      <CC.Box>
        <CC.FormControl w={{ md: '48%' }}>
          <CC.FormLabel>Nom Client</CC.FormLabel>
          <CC.Input bg={bg} type="text" readOnly />
        </CC.FormControl>

        <CC.SimpleGrid
          columns={{ base: 1, md: 2}}
          columnGap={14}
        >
          <CC.FormControl>
            <CC.FormLabel>Agence</CC.FormLabel>
            <CC.Input bg={bg} type="text" readOnly />
          </CC.FormControl>

          <CC.FormControl>
            <CC.FormLabel>Motif Statut</CC.FormLabel>
            <CC.Input bg={bg} type="text" readOnly />
          </CC.FormControl>
        </CC.SimpleGrid>
      </CC.Box>
    </>
  );
};

export default CustomerStatusHistoryMixedHandler;
